export default __webpack_public_path__ + "static/team-image-3-468ee8cf0da9bed3cb069b7621ffe404.png";